<template>
  <div
    :id="panelId"
    role="tabpanel"
    class="tab-panel"
    :aria-labelledby="tabId"
    :hidden="!isActive"
    :tabindex="focusable && isActive ? 0 : undefined"
  >
    <template v-if="!lazy || isActive || hasRendered">
      <slot></slot>
    </template>
  </div>
</template>

<script setup>
import { computed, inject, ref, useAttrs, watch } from 'vue'
import { tabKey } from './key'
import uniqueId from 'lodash/uniqueId'

const attrs = useAttrs()

const props = defineProps({
  lazy: { type: Boolean, default: false },
  focusable: { type: Boolean, default: false },
})

const tabState = inject(tabKey)
const hasRendered = ref(!props.lazy)

const panelId = attrs.id ?? uniqueId('tab-panel-')
const panelIndex = tabState.registerPanel(panelId)

const isActive = computed(() => tabState.activeIndex.value === panelIndex)
const tabId = computed(() => tabState.tabs.value[panelIndex])

watch(
  isActive,
  (newValue) => {
    if (newValue && props.lazy && !hasRendered.value) {
      hasRendered.value = true
    }
  },
  { immediate: true },
)
</script>

<style scoped>
/* Interestingly hidden doesn't work as you'd expect with flex/grid */
.tab-panel[hidden] {
  display: none !important;
}
</style>
